import useAsyncState from '../../utils/useAsyncState';

const useAsyncLogo = useAsyncState;

export default useAsyncLogo;
